module.exports = __webpack_public_path__ + "static/assets/f3f8d3628515f73eaf302be3410a1c9c.svg";